import { c as _c } from "react/compiler-runtime";
interface NewBadgeProps {
  text?: string;
  className?: string;
}
export default function NewBadge(t0) {
  const $ = _c(5);
  const {
    text: t1,
    className
  } = t0;
  const text = t1 === undefined ? "NEW" : t1;
  const t2 = `inline-flex items-center justify-center rounded-md bg-primary-100 px-2 py-0.5 text-caption-strong text-primary-800 ${className || ""}`;
  let t3;
  if ($[0] !== text) {
    t3 = <span>{text}</span>;
    $[0] = text;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}